import React from "react";
import "./CSS/icons.css";

const html = (
  <img
    src="https://www.w3.org/html/logo/downloads/HTML5_Logo_512.png"
    className="icon"
    alt="HTML5 icon"
    key="HTML5-icon"
  />
);
const css = (
  <img
    src="https://cdn1.iconfinder.com/data/icons/logotypes/32/badge-css-3-512.png"
    className="icon"
    alt="CSS3 icon"
    key="CSS3-icon"
  />
);

const javascript = (
  <img
    src="http://www.bobbyberberyan.com/wp-content/uploads/2016/12/ES6LOGO.svg"
    className="icon"
    alt="javascript icon"
    key="javascript-icon"
  />
);

const jQuery = (
  <img
    src="https://cdn.iconscout.com/icon/free/png-256/jquery-10-1175155.png"
    className="icon"
    alt="jQuery icon"
    key="jQuery-icon"
  />
);

const jwtLogo = (
  <img
    src="https://cdn.auth0.com/blog/jwtalgos/logo.png"
    className="icon"
    alt="JSON web token icon"
    key="JWT-icon"
  />
);

const react = (
  <img
    src="https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png"
    className="icon"
    alt="React.js icon"
    key="React-icon"
  />
);

const node = (
  <img
    src="https://cdn.worldvectorlogo.com/logos/nodejs-icon.svg"
    className="icon"
    alt="Node.js icon"
    key="Node-icon"
  />
);

const mongo = (
  <img
    src="https://cdn.iconscout.com/icon/free/png-256/mongodb-3-1175138.png"
    className="icon"
    alt="MongoDB icon"
    key="MongoDB-icon"
  />
);

export { html, css, javascript, jQuery, jwtLogo, react, node, mongo };
